import moment from 'moment';
import 'moment/locale/vi';

export const mappingDateText = (date: string) => {
  if (date.includes('T')) {
    return date.replace('T', 'Thứ ');
  }
  return 'Chủ nhật';
};

export const mappingFullDate = (date: string | Date | null) => {
  const dateFormat = moment(date).format('dd');
  const fullDateFormat = moment(date).format('ll');
  return (
    `${mappingDateText(dateFormat)
    }, ${
      fullDateFormat.replace('tháng', 'Tháng').replace('ngày', '').replace(' năm', ',')
    }`
  );
};
